import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { ISeoComponentProps } from '../components/seo-component/seo-component';

export class SEOBoxModel extends ContentItem {
  get title(): string {
    return get(this._config, 'seo__title.value', '');
  }
  get description(): string {
    return get(this._config, 'seo__description.value', '');
  }
  get ogImage(): string {
    return get(this._config, 'seo__image.value[0].url', '');
  }
  get ogType(): string {
    return get(this._config, 'seo__og_type.value[0].codename', '');
  }
  get noIndex(): string {
    return get(this._config, 'seo__seo_no_index.value[0].codename', '');
  }
  get seoCanonicalLink(): string {
    return get(this._config, 'seo__seo_cannonical_link.value', '');
  }

  get script(): string {
    return get(this._config, 'seo__script.value', '');
  }

  public static create(data: ISEOComponent): ISeoComponentProps {
    const {
      title,
      description,
      ogImage,
      ogType,
      noIndex,
      seoCanonicalLink,
      script
    } = new SEOBoxModel(data);
    return {
      title,
      description,
      ogImage,
      ogType,
      noIndex,
      seoCanonicalLink,
      script
    };
  }
}
